import { call } from "redux-saga/effects";
import { ACTIONS, APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getSearchOrders(action: any): any {
    yield call(
        sagaFunction,
        action,
        CallApi.POST, // or GET, depending on your API
        APIS.ORDERS_AND_FULFILLMENT.GET_SEARCH_ORDERS,
        action.payload,
        true
    );
}

export function* getOrderDetails(action: any): any {
    const orderId = action.payload || "";
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        `${APIS.ORDERS_AND_FULFILLMENT.GET_ORDER_DETAILS}${orderId}`,
        {},
        true
    );
}

export function* getReturnOrderDetails(action: any): any {
    const orderId = action.payload || "";
    yield call(
        sagaFunction,
        action,
        CallApi.GET,
        `${APIS.ORDERS_AND_FULFILLMENT.GET_RETURN_ORDER_DETAILS}?OrderId=${orderId}`,
        {},
        true
    );
}